// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/scaffolding/scaffolding.scss
 ** module id = 19
 ** module chunks = 0 1
 **/